import { AssignButton } from '../components';

type CLAssignButtonProps = {
  isSelected: boolean;
  onAssign: () => void;
};

export const CLAssignButton = ({ isSelected, onAssign }: CLAssignButtonProps) => {
  return (
    <div className="flex w-full justify-end">
      <AssignButton isSelected={isSelected} onAssign={onAssign} isDisabled={false} />
    </div>
  );
};
